import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import { defer } from 'lodash';
import { featureDetector } from '../../common/utils/feature-detector';
import clamp from '../../common/utils/text-overflow-clamp';
import styles from './clamp-text.scss';
export class ClampText extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "isUsingCSSClamp", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "clamp", () => {
      const {
        clampOptions
      } = this.props;
      if (clampOptions.disabled || this.isUsingCSSClamp) {
        return;
      }
      if (this.title) {
        clamp(this.title, clampOptions);
      }
    });
    _defineProperty(this, "saveRef", ref => {
      this.title = ref;
    });
    const isServer = typeof document === 'undefined';
    this.isUsingCSSClamp = isServer || featureDetector.isMultilineClampAvailable() && !props.enforceJSClamp;
  }
  componentDidMount() {
    defer(this.clamp);
  }
  componentDidUpdate() {
    this.clamp();
  }
  render() {
    const {
      text,
      dataHook,
      clampOptions,
      wrapperTag,
      className
    } = this.props;
    const useCss = !clampOptions.disabled && this.isUsingCSSClamp;
    const props = {
      ref: this.saveRef,
      className: classnames(styles.text, {
        [styles.lineClamp]: useCss
      }, className),
      'data-hook': dataHook,
      title: text,
      style: {
        WebkitLineClamp: useCss ? clampOptions.lineClamp : undefined
      }
    };
    return /*#__PURE__*/React.createElement(wrapperTag, props, text);
  }
}
_defineProperty(ClampText, "defaultProps", {
  clampOptions: {
    lineClamp: 2,
    disabled: false
  },
  wrapperTag: 'div',
  enforceJSClamp: false
});
//# sourceMappingURL=clamp-text.js.map